import { AuthUserProfile } from '../Auth/authTypes';
import { MedicalDeclarationFormValues } from './GymManagementInterfaces';
import { MedicalStatusEnum } from '../../components/pages/book-fitness/BookFitness/medical-status.enum';
import { SendMedicalDeclarationRequestDto } from '../../API/gym/dto/request/send-medical-declaration.request.dto';

export const sendMedicalDeclarationDto = (
  profile: AuthUserProfile,
  data: MedicalDeclarationFormValues,
  medicalStatus?: MedicalStatusEnum
): SendMedicalDeclarationRequestDto => {
  const medicalForm = {
    details: {
      full_name: data.fullName,
      id_number: data.idNumber,
      age: data.age,
    },
    medical_questionnaire: {
      heart_disease: data.heartDisease === 'yes',
      rest_chest_pain: data.restChestPain === 'yes',
      daily_chest_pain: data.dailyChestPain === 'yes',
      exercise_chest_pain: data.exerciseChestPain === 'yes',
      lost_balance: data.lostBalance === 'yes',
      lost_consciousness: data.lostConsciousness === 'yes',
      asthma_medical_care: data.asthmaMedicalCare === 'yes',
      asthma_shortness_breath: data.asthmaShortnessBreath === 'yes',
      family_member_heart_disease: data.familyMemberHeartDisease === 'yes',
      family_member_sudden_death: data.familyMemberSuddenDeath === 'yes',
      training_under_medical: data.trainingUnderMedical === 'yes',
      chronic_disease: data.chronicDisease === 'yes',
      pregnancy: data.pregnancy === 'yes',
    },
    declaration: {
      signature: data.signature,
    },
    medical_declaration_additional_info: {
      child_full_name: data.childFullName,
      parent_name: data.parentName,
      child_id_number: data.childIdNumber,
      training_types: data.trainingTypes,
      parent_declaration_date: data.parentDeclarationDate,
      parent_signature: data.parentSignature,
    },
  };

  return {
    user_id: profile.id!,
    updated_by: profile.id!,
    form: medicalForm,
    medical_status: medicalStatus,
    terms: new Date(Date.now()),
  };
};
